// import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
  Button,
} from "@mui/material";
// import PrivateLayout from "../layouts/PrivateLayout";
// import ReusableModal from "./Model";
// import ChatModal from "./ChatModal";

// const Helpdesk = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [query, setQuery] = useState("");
//   const [openTicket, setOpenTicket] = useState(12);
//   const [resoleTicket, setResolveTicket] = useState(50);
//   const [flag, setFlag] = useState(21);
//   const [hover, setHover] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [priority, setPriority] = useState("Medium");
//   const [category, setCategory] = useState("Hardware");

//   const [chatOpen, setChatOpen] = useState(false);
//   const [selectedTicket, setSelectedTicket] = useState(null);
//   const [chatMessages, setChatMessages] = useState({});
//   const [suggestions, setSuggestions] = useState([]);
//   const [highlightIndex, setHighlightIndex] = useState(-1); // for arrow key navigation

//   const tickets = [
//     { id: 124, issue: "Motor won’t switch off", status: "Open", priority: "High", flag: true, lastUpdate: "Today" },
//     { id: 125, issue: "Billing mismatch", status: "Resolved", priority: "Low", flag: true, lastUpdate: "2d ago" },
//     { id: 126, issue: "App crash on login", status: "Open", priority: "Medium", flag: true, lastUpdate: "5h ago" },
//   ];

//   // Handle suggestions
//   useEffect(() => {
//     if (query.trim() === "") {
//       setSuggestions([]);
//     } else {
//       const filtered = tickets.filter((t) =>
//         t.issue.toLowerCase().includes(query.toLowerCase())
//       );
//       const exactMatch = filtered.some(
//         (t) => t.issue.toLowerCase() === query.toLowerCase()
//       );
//       if (exactMatch) {
//         setSuggestions([]);
//       } else {
//         setSuggestions(filtered);
//       }
//     }
//   }, [query]);

//   const handleSuggestionClick = (s) => {
//     setQuery(s.issue);
//     setSuggestions([]);
//     setHighlightIndex(-1);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert("Issue submitted!");
//   };

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 1024);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleClose = () => setOpen(false);

//   const DesktopStyle = {
//     Header: {
//       display: "flex",
//       flexWrap: "wrap",
//       alignItems: "center",
//       gap: "10px",
//       width: "100%",
//       maxWidth: isMobile ? "500px" : "800px",
//       paddingTop: "1rem",
//       fontWeight: "bold",
//     },
//     input: {
//       width: "100%",
//       padding: "10px 12px 10px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "4px",
//       fontSize: "14px",
//       boxSizing: "border-box",
//     },
//     icon: {
//       position: "absolute",
//       top: "50%",
//       left: "10px",
//       transform: "translateY(-50%)",
//       fontSize: "16px",
//       color: "#555",
//     },
//     button: {
//       flex: "0 0 auto",
//       padding: "10px 16px",
//       border: "1px solid #ccc",
//       borderRadius: "4px",
//       backgroundColor: "blue",
//       color: "white",
//       cursor: "pointer",
//       fontSize: "14px",
//       whiteSpace: "nowrap",
//     },
//   };

//   const highlightText = (text, query) => {
//     if (!query) return text;
//     const regex = new RegExp(`(${query})`, "gi");
//     const parts = text.split(regex);
//     return parts.map((part, i) =>
//       part.toLowerCase() === query.toLowerCase() ? (
//         <mark key={i} style={{ backgroundColor: "yellow", padding: 0 }}>
//           {part}
//         </mark>
//       ) : (
//         part
//       )
//     );
//   };

//   const displayedTickets =
//     query.trim() === ""
//       ? tickets
//       : tickets.filter((t) =>
//           t.issue.toLowerCase().includes(query.toLowerCase())
//         );

//   return (
//     <>
//       <Box component="main" sx={{ flexGrow: 1, py: 2 }}>
//         <div
//           style={{
//             width: "100%",
//             paddingLeft: isMobile ? "0.5rem" : "2rem",
//             paddingRight: isMobile ? "0.5rem" : "",
//           }}
//         >
//           {/* Search + Report */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "10px",
//               width: "100%",
//               maxWidth: isMobile ? "500px" : "800px",
//               paddingTop: "1rem",
//               justifyContent: "center",
//             }}
//           >
//             {/* Search Box */}
//             <div style={{ position: "relative", flex: "1 1 250px" }}>
//               <span style={DesktopStyle.icon}>🔍</span>
//               <input
//                 type="text"
//                 placeholder="Search FAQs or Issues"
//                 value={query}
//                 onChange={(e) => {
//                   setQuery(e.target.value);
//                   setHighlightIndex(-1);
//                 }}
//                 onKeyDown={(e) => {
//     if (suggestions.length === 0) return;

//     if (e.key === "ArrowDown") {
//       e.preventDefault(); // prevent cursor moving in input
//       setHighlightIndex((prev) =>
//         prev < suggestions.length - 1 ? prev + 1 : 0
//       ); // move highlight down
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setHighlightIndex((prev) =>
//         prev > 0 ? prev - 1 : suggestions.length - 1
//       ); // move highlight up
//     } else if (e.key === "Enter") {
//       e.preventDefault();
//       if (highlightIndex >= 0 && highlightIndex < suggestions.length) {
//         // ✅ Pick highlighted suggestion when pressing Enter
//         handleSuggestionClick(suggestions[highlightIndex]);
//       } else {
//         // ✅ If no suggestion highlighted, just search normally
//         alert(`Searching for: ${query}`);
//       }
//     }
//   }}
//   style={DesktopStyle.input}
// />

//               {/* Suggestions Dropdown */}
//               {suggestions.length > 0 && (
//                 <ul
//                   style={{
//                     listStyle: "none",
//                     margin: 0,
//                     padding: "5px",
//                     position: "absolute",
//                     top: "100%",
//                     left: 0,
//                     right: 0,
//                     background: "white",
//                     border: "1px solid #ccc",
//                     borderRadius: "4px",
//                     zIndex: 10,
//                     maxHeight: "200px",
//                     overflowY: "auto",
//                   }}
//                 >
//                   {suggestions.map((s, i) => (
//                     <li
//                       key={s.id}
//                       onClick={() => handleSuggestionClick(s)}
//                       style={{
//                         padding: "8px",
//                         cursor: "pointer",
//                         backgroundColor: highlightIndex === i ? "#e0e0e0" : "white",
//                       }}
//                     >
//                       {highlightText(s.issue, query)}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>

//             {/* Report Button */}
//             <button
//               style={{
//                 ...DesktopStyle.button,
//                 backgroundColor: hover ? "#4293f5" : "blue",
//               }}
//               onMouseEnter={() => setHover(true)}
//               onMouseLeave={() => setHover(false)}
//               onClick={() => setOpen(true)}
//             >
//               Report an Issue
//             </button>
//           </div>

//           {/* Quick Stats */}
//           <div>
//             <div style={{ fontSize: "17px", fontWeight: "bold", marginBottom: "8px", marginTop: "18px" }}>Quick Stats:</div>
//             <div style={{
//               display: "grid",
//               gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4, 1fr)",
//               gap: "16px",
//               marginTop: "16px"
//             }}>
//               {/* Open Tickets */}
//               <div style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "8px",
//                 padding: "16px",
//                 textAlign: "center",
//                 border: "1px solid #ccc",
//               }}>
//                 <h6 style={{ margin: "0 0 8px", fontSize: "16px" }}>Open Tickets</h6>
//                 <div style={{ fontSize: "22px", fontWeight: "bold" }}>{openTicket}</div>
//               </div>
//               {/* Resolved Tickets */}
//               <div style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "8px",
//                 padding: "16px",
//                 textAlign: "center",
//                 border: "1px solid #ccc",
//               }}>
//                 <h6 style={{ margin: "0 0 8px", fontSize: "16px" }}>Resolved Tickets</h6>
//                 <div style={{ fontSize: "22px", fontWeight: "bold" }}>{resoleTicket}</div>
//               </div>
//               {/* Flagged Issues */}
//               <div style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "8px",
//                 padding: "16px",
//                 textAlign: "center",
//                 border: "1px solid #ccc",
//               }}>
//                 <h6 style={{ margin: "0 0 8px", fontSize: "16px" }}>Flagged Issues</h6>
//                 <div style={{ fontSize: "22px", fontWeight: "bold" }}>{flag}</div>
//               </div>
//               {/* Response Time */}
//               <div style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "8px",
//                 padding: "16px",
//                 textAlign: "center",
//                 border: "1px solid #ccc",
//               }}>
//                 <h6 style={{ margin: "0 0 8px", fontSize: "16px" }}>Response Time</h6>
//                 <div style={{ fontSize: "16px", fontWeight: "bold" }}>Today</div>
//               </div>
//             </div>
//           </div>

//           {/* Recent Tickets */}
//           <div style={{ marginTop: "20px" }}>
//             <div style={{ fontSize: "17px", fontWeight: "bold", marginBottom: "20px", marginTop: "20px" }}>Recent Tickets:</div>
//             <div style={{ overflowX: "auto",maxWidth: "100%" }}>
//               <table style={{ width: "100%",minWidth: "20px", borderCollapse: "collapse", textAlign: "center" }}>
//                 <thead style={{ backgroundColor: "#f0f0f0" }}>
//                   <tr>
//                     {["ID", "Issue", "Status", "Priority", "Flag", "Last Update", "Chat"].map((head) => (
//                       <th key={head} style={{ border: "1px solid #ccc", padding: "8px" }}>{head}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {displayedTickets.map((ticket) => (
//                     <tr key={ticket.id}>
//                       <td style={{ border: "1px solid #ccc", padding: "8px" }}>{ticket.id}</td>
//                       <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "left" }}>{ticket.issue}</td>
//                       <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                         <span style={{
//                           padding: "4px 8px",
//                           borderRadius: "4px",
//                           color: ticket.status === "Resolved" ? "#fff" : "#000",
//                           backgroundColor: ticket.status === "Resolved" ? "green" : "yellow",
//                           fontWeight: "bold",
//                         }}>
//                           {ticket.status}
//                         </span>
//                       </td>
//                       <td style={{ border: "1px solid #ccc", padding: "8px" }}>{ticket.priority}</td>
//                       <td style={{ border: "1px solid #ccc", padding: "8px" }}>{ticket.flag ? "7" : ""}</td>
//                       <td style={{ border: "1px solid #ccc", padding: "8px" }}>{ticket.lastUpdate}</td>
//                       <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                         <button
//                           style={{ padding: "4px 8px", borderRadius: "4px", border: "1px solid #333", cursor: "pointer" }}
//                           onClick={() => { setSelectedTicket(ticket); setChatOpen(true); }}
//                         >
//                           Chat
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </Box>

//       {/* Report Issue Modal */}
//       <ReusableModal open={open} onClose={handleClose}>
//         <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
//           <Typography variant="h5" fontWeight="bold" gutterBottom>Report an Issue</Typography>
//           <TextField label="Title" placeholder="Enter issue title" fullWidth required />
//           <TextField label="Description" placeholder="Describe the issue..." fullWidth required multiline rows={4} />
//           <TextField select label="Category" value={category} onChange={(e) => setCategory(e.target.value)} fullWidth>
//             <MenuItem value="Hardware">Hardware</MenuItem>
//             <MenuItem value="Software">Software</MenuItem>
//             <MenuItem value="Billing">Billing</MenuItem>
//             <MenuItem value="Other">Other</MenuItem>
//           </TextField>
//           <Box>
//             <Typography variant="subtitle1" sx={{ mb: 1 }}>Priority:</Typography>
//             <ToggleButtonGroup value={priority} exclusive onChange={(e, newPriority) => newPriority && setPriority(newPriority)} fullWidth>
//               <ToggleButton value="Low">Low</ToggleButton>
//               <ToggleButton value="Medium">Medium</ToggleButton>
//               <ToggleButton value="High">High</ToggleButton>
//             </ToggleButtonGroup>
//           </Box>
//           <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
//             <Button type="submit" variant="contained" size="large" sx={{ flex: 1, borderRadius: 2, background: "linear-gradient(90deg, #007bff, #0056b3)" }}>Submit Issue</Button>
//             <Button variant="outlined" size="large" onClick={handleClose} sx={{ flex: 1, borderRadius: 2, borderColor: "#999", color: "#333" }}>Cancel</Button>
//           </Box>
//         </Box>
//       </ReusableModal>

//       {/* Chat Modal */}
//       <ChatModal open={chatOpen} onClose={() => setChatOpen(false)} ticket={selectedTicket} chatMessages={chatMessages} setChatMessages={setChatMessages} />
//     </>
//   );
// };

// Helpdesk.getLayout = (page) => <PrivateLayout>{page}</PrivateLayout>;

// export default Helpdesk;


import React, { useState, useEffect } from "react";
import "./Helpdesk.css";
import ReusableModal from "./Model";
import ChatModal from "./ChatModal";

const Helpdesk = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [query, setQuery] = useState("");
  const [openTicket, setOpenTicket] = useState(12);
  const [resoleTicket, setResolveTicket] = useState(50);
  const [flag, setFlag] = useState(21);
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(false);
  const [priority, setPriority] = useState("Medium");
  const [category, setCategory] = useState("Hardware");

  // ✅ Chat modal states
  const [chatOpen, setChatOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [chatMessages, setChatMessages] = useState({});

  const [suggestions, setSuggestions] = useState([]);
  const [highlightIndex, setHighlightIndex] = useState(-1);

  // ✅ Scroll highlighted suggestion into view when moving with arrow keys
  useEffect(() => {
    if (highlightIndex >= 0) {
      const element = document.getElementById(`suggestion-${highlightIndex}`);
      if (element) element.scrollIntoView({ block: "nearest" });
    }
  }, [highlightIndex]);

  // ✅ Reset highlight when new suggestions appear
  useEffect(() => {
    setHighlightIndex(-1);
  }, [suggestions]);

  const tickets = [
    {
      id: 124,
      issue: "Motor won’t switch off",
      status: "Open",
      priority: "High",
      flag: true,
      lastUpdate: "Today",
    },
    {
      id: 125,
      issue: "Billing mismatch",
      status: "Resolved",
      priority: "Low",
      flag: true,
      lastUpdate: "2d ago",
    },
    {
      id: 126,
      issue: "App crash on login",
      status: "Open",
      priority: "Medium",
      flag: true,
      lastUpdate: "5h ago",
    },
  ];

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (query.trim() === "") {
      setSuggestions([]);
      setHighlightIndex(-1);
      return;
    }
    const filtered = tickets.filter((t) =>
      t.issue.toLowerCase().includes(query.toLowerCase())
    );
    const exactMatch = filtered.some(
      (t) => t.issue.toLowerCase() === query.toLowerCase()
    );
    setSuggestions(exactMatch ? [] : filtered);
    setHighlightIndex(-1);
  }, [query]);

  const handleSuggestionClick = (s) => {
    setQuery(s.issue);
    setSuggestions([]);
    setHighlightIndex(-1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Issue submitted!");
    setOpen(false);
  };

  const handleClose = () => setOpen(false);

  const displayedTickets =
    query.trim() === ""
      ? tickets
      : tickets.filter((t) =>
          t.issue.toLowerCase().includes(query.toLowerCase())
        );

  return (
    <div className="helpdesk-container">
      {/* 🔍 Search + Report (Now left-aligned) */}
      <div className="search-bar left-align">
        <div className="search-box">
          <span className="search-icon">🔍</span>
          <input
            className="search-input"
            type="text"
            placeholder="Search FAQs or Issues"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (suggestions.length > 0) {
                if (e.key === "ArrowDown") {
                  e.preventDefault();
                  setHighlightIndex((p) => (p + 1) % suggestions.length);
                } else if (e.key === "ArrowUp") {
                  e.preventDefault();
                  setHighlightIndex((p) =>
                    p - 1 < 0 ? suggestions.length - 1 : p - 1
                  );
                } else if (e.key === "Enter") {
                  e.preventDefault();
                  if (highlightIndex >= 0)
                    handleSuggestionClick(suggestions[highlightIndex]);
                }
              }
            }}
          />
          {suggestions.length > 0 && (
            <ul className="suggestion-list">
              {suggestions.map((s, i) => (
                <li
                  key={s.id}
                  id={`suggestion-${i}`}
                  className={
                    "suggestion-item " +
                    (highlightIndex === i ? "highlighted" : "")
                  }
                  onClick={() => handleSuggestionClick(s)}
                >
                  {s.issue.split(new RegExp(`(${query})`, "gi")).map(
                    (part, idx) =>
                      part.toLowerCase() === query.toLowerCase() ? (
                        <mark key={idx}>{part}</mark>
                      ) : (
                        <span key={idx}>{part}</span>
                      )
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>

        <button
          className="report-btn"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={() => setOpen(true)}
          style={{ backgroundColor: hover ? "#0000ff" : "#0000ff" }}
        >
          Report an Issue
        </button>
      </div>

      {/* 📊 Quick Stats */}
      <div className="section-header">Quick Stats:</div>
      <div className="quick-stats">
        <div className="stats-card">
          <h6 style={{ fontSize: "14px", fontWeight: "600", margin: "0 0 8px" }}>
            Open Tickets
          </h6>
          <div
            className="stat-value"
            style={{ fontSize: "22px", fontWeight: "500" }}
          >
            {openTicket}
          </div>
        </div>
        <div className="stats-card">
          <h6 style={{ fontSize: "14px", fontWeight: "600", margin: "0 0 8px" }}>
            Resolved Tickets
          </h6>
          <div
            className="stat-value"
            style={{ fontSize: "22px", fontWeight: "500" }}
          >
            {resoleTicket}
          </div>
        </div>
        <div className="stats-card">
          <h6 style={{ fontSize: "14px", fontWeight: "600", margin: "0 0 8px" }}>
            Flagged Issues
          </h6>
          <div
            className="stat-value"
            style={{ fontSize: "22px", fontWeight: "500" }}
          >
            {flag}
          </div>
        </div>
        <div className="stats-card">
          <h6 style={{ fontSize: "14px", fontWeight: "600", margin: "0 0 8px" }}>
            Response Time
          </h6>
          <div
            className="stat-value"
            style={{ fontSize: "22px", fontWeight: "500" }}
          >
            Today
          </div>
        </div>
      </div>

      {/* 📋 Recent Tickets */}
      <div className="table-section">
        <div className="section-header">Recent Tickets :</div>
        <div className="table-wrapper">
          <table className="custom-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Issue</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Flag</th>
                <th>Last Update</th>
                <th>Chat</th>
              </tr>
            </thead>
            <tbody>
              {displayedTickets.map((t) => (
                <tr key={t.id}>
                  <td>{t.id}</td>
                  <td className="text-left">{t.issue}</td>
                  <td>
                    <span
                      className={
                        t.status === "Resolved"
                          ? "badge-success"
                          : "badge-warning"
                      }
                    >
                      {t.status}
                    </span>
                  </td>
                  <td>{t.priority}</td>
                  <td>{t.flag ? "7" : ""}</td>
                  <td>{t.lastUpdate}</td>
                  <td>
                    <button
                      className="chat-btn"
                      onClick={() => {
                        setSelectedTicket(t);
                        setChatOpen(true);
                      }}
                    >
                      Chat
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Report Issue Modal */}
      <ReusableModal open={open} onClose={handleClose}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Report an Issue
          </Typography>
          <TextField label="Title" placeholder="Enter issue title" fullWidth required />
          <TextField
            label="Description"
            placeholder="Describe the issue..."
            fullWidth
            required
            multiline
            rows={4}
          />
          <TextField
            select
            label="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            fullWidth
          >
            <MenuItem value="Hardware">Hardware</MenuItem>
            <MenuItem value="Software">Software</MenuItem>
            <MenuItem value="Billing">Billing</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Priority:
            </Typography>
            <ToggleButtonGroup
              value={priority}
              exclusive
              onChange={(e, newPriority) => newPriority && setPriority(newPriority)}
              fullWidth
            >
              <ToggleButton value="Low">Low</ToggleButton>
              <ToggleButton value="Medium">Medium</ToggleButton>
              <ToggleButton value="High">High</ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                flex: 1,
                borderRadius: 2,
                background: "linear-gradient(90deg, #007bff, #0056b3)",
                "&:hover": {
                  background: "linear-gradient(90deg, #0056b3, #007bff)",
                },
              }}
            >
              Submit Issue
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={handleClose}
              sx={{
                flex: 1,
                borderRadius: 2,
                borderColor: "#999",
                color: "#333",
                "&:hover": {
                  borderColor: "#555",
                  color: "#000",
                  backgroundColor: "rgba(0,0,0,0.05)",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </ReusableModal>

      {/* Report Issue Modal */}
      <ReusableModal open={open} onClose={handleClose}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Report an Issue
          </Typography>
          <TextField label="Title" placeholder="Enter issue title" fullWidth required />
          <TextField
            label="Description"
            placeholder="Describe the issue..."
            fullWidth
            required
            multiline
            rows={4}
          />
          <TextField
            select
            label="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            fullWidth
          >
            <MenuItem value="Hardware">Hardware</MenuItem>
            <MenuItem value="Software">Software</MenuItem>
            <MenuItem value="Billing">Billing</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Priority:
            </Typography>
            <ToggleButtonGroup
              value={priority}
              exclusive
              onChange={(e, newPriority) => newPriority && setPriority(newPriority)}
              fullWidth
            >
              <ToggleButton value="Low">Low</ToggleButton>
              <ToggleButton value="Medium">Medium</ToggleButton>
              <ToggleButton value="High">High</ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                flex: 1,
                borderRadius: 2,
                background: "linear-gradient(90deg, #007bff, #0056b3)",
                "&:hover": {
                  background: "linear-gradient(90deg, #0056b3, #007bff)",
                },
              }}
            >
              Submit Issue
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={handleClose}
              sx={{
                flex: 1,
                borderRadius: 2,
                borderColor: "#999",
                color: "#333",
                "&:hover": {
                  borderColor: "#555",
                  color: "#000",
                  backgroundColor: "rgba(0,0,0,0.05)",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </ReusableModal>

      {/* 🗨️ Chat Modal (This was missing) */}
      <ChatModal
        open={chatOpen}
        onClose={() => setChatOpen(false)}
        ticket={selectedTicket}
        chatMessages={chatMessages}
        setChatMessages={setChatMessages}
      />
    </div>
  );
};

export default Helpdesk;
